import { merge, omit } from "lodash-es";

import { IActionStates, IAPIState, IDataState, IPagination } from "shared/types";

import { IDataKeys } from "shared/types";

// Helper methods to set loading state for a data request
export const setStateLoading = (state: IDataState, url: string) => {
  state.meta = {
    ...state.meta,
    [url]: {
      ...state.meta?.[url], // keep pagination
      api: { status: IAPIState.pending },
    },
  };
};

// Helper methods to set fulfilled state for a data request
export const setStateFulfilled = (
  state: IDataState,
  payload?: any,
  url?: string,
  payloadMeta?: any,
  deleteOldPayload?: boolean
) => {
  state.meta = url
    ? {
        ...state.meta,
        [url]: {
          api: { status: IAPIState.succeeded, error: null },
          ...payloadMeta,
        },
      }
    : state.meta;

  const keys = Object.keys(omit(payload, "pagination", "meta"));

  // update state for each key instead of the whole state.data
  keys.forEach(key => {
    if (deleteOldPayload) {
      const id = Object.keys(payload[key] || {})[0];
      const keyDataInStore = state.data[key as IDataKeys];

      // delete object before merging to avoid
      // merging old attributes into new object
      if (keyDataInStore && id) {
        delete keyDataInStore[id];
      }
    }

    state.data[key as IDataKeys] = merge({}, state.data[key as IDataKeys], payload[key]);
  });
};

// Helper methods to set rejected state for a data request
export const setStateRejected = (state: IDataState, payload: any | undefined, url: string) => {
  state.meta = {
    ...state.meta,
    [url]: {
      ...state.meta?.[url], // keep pagination
      api: {
        status: IAPIState.failed,
        error: payload,
      },
    },
  };
};

export const setStatePagination = (
  state: IDataState,
  paginationKey: string,
  page: number,
  payload?: any,
  pagination?: IPagination
) => {
  state.pagination = {
    ...state.pagination,
    [paginationKey]: {
      currentPage: page,
      ...(pagination || {}),
      totalPages: pagination?.totalPages || 0,
      pages: payload
        ? {
            ...state.pagination?.[paginationKey]?.pages,
            [page]: Object.keys(payload),
          }
        : {},
    },
  };
};

export const getAction = (state: IActionStates, type: string, meta?: { arg: any }) => {
  if (meta?.arg && typeof meta.arg === "object" && "action" in meta.arg) {
    return meta.arg.action;
  }
  return type.replace(`/${state}`, "");
};
